export const SAVE_CONFIGURATION = 'configuration/save'

export const saveConfiguration = (payload) => ({
  type: SAVE_CONFIGURATION, payload
})
